import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import EditOutlined from '@mui/icons-material/EditOutlined'
import { Link } from 'react-router-dom'
import { TABLE_ACTION_ICON_BUTTON_SX } from './tableActionIconButtonSx'

export type EditButtonProps = {
  to?: string
  href?: string
  onClick?: () => void
  hidden?: boolean
  tooltip?: string
  target?: '_blank' | '_self'
  disabled?: boolean
}

const EditButton: React.FC<EditButtonProps> = ({
  to,
  href,
  onClick,
  hidden = false,
  tooltip = 'Chỉnh sửa thông tin',
  target = '_self',
  disabled = false,
}) => {
  if (hidden) return null

  const icon = <EditOutlined />

  if (onClick) {
    return (
      <Tooltip title={tooltip}>
        <span>
          <IconButton
            size="small"
            onClick={onClick}
            disabled={disabled}
            color="primary"
            aria-label={tooltip}
            sx={TABLE_ACTION_ICON_BUTTON_SX}
          >
            {icon}
          </IconButton>
        </span>
      </Tooltip>
    )
  }

  if (to) {
    return (
      <Tooltip title={tooltip}>
        <span>
          <IconButton
            size="small"
            component={Link}
            to={to}
            target={target}
            disabled={disabled}
            color="primary"
            aria-label={tooltip}
            sx={TABLE_ACTION_ICON_BUTTON_SX}
          >
            {icon}
          </IconButton>
        </span>
      </Tooltip>
    )
  }

  if (href) {
    return (
      <Tooltip title={tooltip}>
        <span>
          <IconButton
            size="small"
            component="a"
            href={href}
            target={target}
            disabled={disabled}
            color="primary"
            aria-label={tooltip}
            sx={TABLE_ACTION_ICON_BUTTON_SX}
          >
            {icon}
          </IconButton>
        </span>
      </Tooltip>
    )
  }

  return null
}

export default EditButton
